export default "__VITE_ASSET__DDyZqtIG__"